import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ImportComponent } from '../import.component';

@Component({
    selector: 'app-partner-import',
    templateUrl: './partner-import.component.html',
    styleUrls: ['./partner-import.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ImportComponent]
})
export class PartnerImportComponent {
}
